"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContent.default;
  }
});

var _DialogContent = _interopRequireDefault(require("./DialogContent"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/DialogContent/index.js
 ** module id = 837
 ** module chunks = 0
 **/